// extracted by mini-css-extract-plugin
export default {"ticketPortal":"portal_ticketPortal__UaMtR","ticketPortalText":"portal_ticketPortalText__aPGa0"};